import { dispatch } from '__common/store';
import { GET_ADDRESS_BY_ZIP } from '../roofsSelectorMapActions';
import { ICITY_STATE } from '../utils/cityModel';

export function getAreaByZip(zipCode: string, cb: (data: ICITY_STATE) => void) {
  dispatch(GET_ADDRESS_BY_ZIP(zipCode, cb));
} 
